module.exports = __webpack_public_path__ + "img/chord_3.eef694d6.jpg";